import script from "./DocumentosLista.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentosLista.vue?vue&type=script&setup=true&lang=js"

import "./DocumentosLista.vue?vue&type=style&index=0&id=05423097&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05423097"]])

export default __exports__